module.exports = __webpack_public_path__ + "img/BUY.db1c3b5a.svg";